<template>
	<el-tabs type="border-card"  v-model="tabs" @tab-remove="Tabremove">
		<el-tab-pane label="运费模板" name="lie">
			<el-table :data="lie" style="width: 100%">
				<el-table-column prop="id" label="ID" width="80"></el-table-column>
				<el-table-column prop="ming" label="名称" width="180"></el-table-column>
				<el-table-column prop="shouzhong" label="首重"></el-table-column>
				<el-table-column prop="shoujia" label="首重价格(元)"></el-table-column>
				<el-table-column prop="xuzhong" label="续重"></el-table-column>
				<el-table-column prop="xujia" label="续重价格(元)"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="shu">
						<el-button icon="el-icon-edit" size="small" @click="Bianji(shu.row)"></el-button>
						<el-button icon="el-icon-close" size="small" @click="Shanchu(shu.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-tab-pane>
		<el-tab-pane :label="shu.id?'编辑模板':'新增模板'" name="xinzeng" lazy :closable="shu.id>0">
			<el-form ref="form" :model="shu" label-width="80px">
				<el-form-item label="模板名称">
					<el-input v-model="shu.ming"></el-input>
				</el-form-item>
				<el-form-item label="通常地区">
					<div class="kuaidi_input">
						<el-input v-model="shu.shouzhong">						
							<template slot="prepend">首重(g)</template>
						</el-input>
						<el-input v-model="shu.shoujia">						
							<template slot="prepend">价格(元)</template>
						</el-input>						
						<el-input v-model="shu.xuzhong">
							<template slot="prepend">续重(g)</template>
						</el-input>
						<el-input v-model="shu.xujia">
							<template slot="prepend">价格(元)</template>
						</el-input>
					</div>
					<div class="tishi">根据重量来计算运费，当物品不足《首重重量》时，按照《首重费用》计算，超过部分按照《续重重量》和《续重费用》乘积来计算</div>
				</el-form-item>	
				<el-form-item label="开启偏远">
					<el-radio-group v-model="shu.kaiqipianyuan">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item> 
				<el-form-item label="偏远地区" v-if="shu.kaiqipianyuan==1">
					<div class="kuaidi_input">
						<el-input v-model="shu.pianyuanshouzhong">
							<template slot="prepend">首重(g)</template>
						</el-input>
						<el-input v-model="shu.pianyuanshoujia">
							<template slot="prepend">价格(元)</template>
						</el-input>
						<el-input v-model="shu.pianyuanxuzhong">
							<template slot="prepend">续重(g)</template>
						</el-input>
						<el-input v-model="shu.pianyuanxujia">
							<template slot="prepend">价格(元)</template>
						</el-input>
					</div>
					<Dizhi v-model="shu.pianyuandiqu" liandong="2" :props='{ multiple: true }' style="width: 100%;margin-top:10px;" v-if="tabs=='xinzeng'"></Dizhi>
				</el-form-item>
				<el-form-item label="是否显示">
					<el-radio-group v-model="shu.zhuangtai">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item> 
			</el-form>			
			<tijiao @click="Tijiao"></tijiao>
		</el-tab-pane>
    </el-tabs>
		
</template>

<script>
	let that;
	import Dizhi from '../../zujian/Dizhi_Duoxuan'
	export default {
		data() {
			return {
				so: {
					ye: 1,
					jitiao: 20
				},
				lie: [],
				shu: {},
				tabs:'lie',
				
			}
		},
		created() {
			that = this;
			this.CSH();
		},
		components: {Dizhi},
		methods: {
			CSH() {
				this.$post('k=kuaidi', that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Tijiao(){			
				this.$post('k=kuaidi&c=xiugai',that.shu, function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi){
						that.CSH();
						if(!that.shu.id){
							that.shu=[];
						}					
					}
				});
			},
			Tabremove(e){
				that.tabs='lie';
				that.shu={};				
			},
			Bianji(e){
				that.tabs='xinzeng';
				that.shu=e;
			},	
			Shanchu(e){
				
				this.$confirm('确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// this.shu.splice(e.$index, 1);
					this.$post('k=kuaidi&c=shandiao',{id:e.id},function(s) {
						that.$xiaoxi(s.shu);
						if(s.shi){
							that.CSH();										
						}
					});
					
					
				});
			},
		},
	}
</script>

<style >
	.box-card {}

	.el-card__header {
		background: #f7fafa;
	}
	.tishi {
		color: #737373;
	}

	
	.kuaidi_input{display: flex;}
	.kuaidi_input .el-input-group{width: 25%;}
	.kuaidi_input .el-input__inner,.kuaidi_input .el-input-group__prepend{border-radius: 0px;}
	
</style>
